import i18n from '@/locales/index';

export function rowDragDefaultData() {
  return {
    enabled: false,
    disabled: false,
    disabledTip: '当前行不支持拖动'
  };
}

// 统计类型
export const aggregationTypes = {
  sum: { label: i18n.global.t('求和'), value: 'sum' },
  none: { label: i18n.global.t('不展示'), value: 'none' }
};

// 指定默认汇总类型
function setDefault(data) {
  return { ...data, default: true };
}

export const valueTypeAggregation = {
  digital: [setDefault(aggregationTypes.sum)],
  amount: [setDefault(aggregationTypes.sum)]
};

// 字段类型统计类型
export const fieldTypeAggregation = {
  // 数字
  7: valueTypeAggregation.digital,
  // 金额
  16: valueTypeAggregation.amount,
  // 计算字段
  24: {
    // 数字
    7: valueTypeAggregation.digital,
    // 金额
    16: valueTypeAggregation.amount,
    // 汇总数字
    5: valueTypeAggregation.digital,
    // 汇总金额
    6: valueTypeAggregation.amount
  }
};

export const summaryStatus = {
  loading: Symbol('loading'),
  error: Symbol('error')
};
